import Countdown from "react-countdown";
import { withTranslation } from "react-i18next";

function CountdownComponentCard({ t, date, serverTime, setServerTime, clientTime, setClientTime, onComplete }) {
    const handleNow = () => {
        return serverTime;
    };

    const onTick = () => {
        let now = Date.now();
        setServerTime(serverTime + (now - clientTime));
        setClientTime(now);
    };

    const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
            onComplete();  // Llama a onComplete cuando el contador llega a 0
            return <span>{t('cita_ha_comenzado')}</span>;
        } else {
            return <span>{t('proxima_cita_en')} {hours < 10 ? `0${hours}` : hours}:{minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}</span>;
        }
    };

    return (
        <Countdown
            date={date}
            renderer={renderer}
            onTick={onTick}
            now={handleNow}
        />
    );
}

export default withTranslation()(CountdownComponentCard);